import React, { Component } from 'react';
class renderListQuestao extends Component {

    render() {
        return (          
                <div className="panel panel-default" key={this.props.chave}>
                            <div className="panel-body">
                              <p>{this.props.pergunta}</p>
                            </div>
                            <ul className="list-group">
                              <li className="list-group-item"><div className="opcao">A)</div> {this.props.opcao_a}</li>
                              <li className="list-group-item"><div className="opcao">B)</div> {this.props.opcao_b}</li>
                              <li className="list-group-item"><div className="opcao">C)</div> {this.props.opcao_c}</li>
                              <li className="list-group-item"><div className="opcao">D)</div> {this.props.opcao_d}</li>
                              <li className="list-group-item"><div className="opcao">Resposta correta:)</div> {this.props.resposta}</li>
                            </ul>
                            <div className="panel-footer clearfix">
                               {this.props.button.map((elem,i) => {return <span key={i}>{elem}</span> })}  
                            </div>
                          </div>
                
          
        );
    }
}

export default renderListQuestao;


// WEBPACK FOOTER //
// ./src/container/renderListQuestao.js